import { loadablePage } from 'src/utils/loadable';

export default loadablePage(
  () =>
    import(
      /* webpackChunkName: "pages.personalData" */ /* webpackPrefetch: true */
      './PersonalData.component'
    ),
);
